import { isEqual } from 'lodash'

export const getChangedValues = (values, initialValues) => {
  if (Array.isArray(values)) {
    return values?.reduce((acc, value) => {
      const hasChanged = initialValues?.every(
        (initialValue) => !isEqual(initialValue, value)
      )

      if (hasChanged) {
        return [...acc, value]
      }

      return acc
    }, [])
  }

  return Object.entries(values)?.reduce((acc, [key, value]) => {
    const hasChanged = !isEqual(initialValues[key], value)

    if (hasChanged) {
      acc[key] = value
    }

    return acc
  }, {})
}

export const createRequiredLabel = (label = '') => {
  return (
    <div>
      {label} <span className="color-danger">*</span>
    </div>
  )
}

export const isChangedValue = (initialValue, value) => {
  return initialValue !== value
}
